import axios from 'axios'

export default {
  methods: {

    languagesGetToken () {
      const token = localStorage.getItem('token')
      return token || null
    },

    async languagesVerifyPassword (pass) {
      try {
        const {data} = await axios.post('/api/languages/login', {}, {
          headers: {'X-Login-Token': pass}
        })
        // if we're here it means it worked
        localStorage.setItem('token', pass)
        this.$store.commit('SetAvailableLanguages', data)
        return true
      } catch (e) {
        localStorage.removeItem('token')
        return false
      }
    },

    async languagesGetOne (code) {
      try {
        const { data: snipDocs } = await axios.get('/api/languages/get/' + code, {
          headers: {'X-Login-Token': this.languagesGetToken()}
        })
        this.$store.commit('SetLanguageSnips', snipDocs)
        // console.log('Docs', snipDocs)
      } catch (e) {
        console.log('Error getting one', e.message)
        return false
      }
    },

    async languagesGetMissing (code) {
      try {
        const { data: snipDocs } = await axios.get('/api/languages/missing/' + code, {
          headers: {'X-Login-Token': this.languagesGetToken()}
        })
        this.$store.commit('SetMissingSnips', snipDocs)
        // console.log('Docs', snipDocs)
      } catch (e) {
        console.log('Error getting one', e.message)
        return false
      }
    },

    async languagesSaveSnip (lang, doc) {
      try {
        console.log('Saving snip doc', doc)
        const { data: snipDocs } = await axios.post('/api/languages/save_snip/' + lang, doc, {
          headers: {'X-Login-Token': this.languagesGetToken()}
        })
        console.log('Docs', snipDocs)
      } catch (e) {
        console.log('Error saving snip', e.message)
        return false
      }
    },

    async languagesSaveMultipleSnips (lang, listOf) {
      try {
        // extract snips from store
        const snipsToSave = this.$store.state.snips.filter(item => {
          return (listOf.indexOf(item._id) > -1)
        })
        const { data } = await axios.post('/api/languages/save_multiple/' + lang, snipsToSave, {
          headers: {'X-Login-Token': this.languagesGetToken()}
        })
        console.log('Saving multiple', snipsToSave, data)
      } catch (e) {
        console.log('Error saving multiple snips', e.message)
        return false
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/languages.js